import {NonNegativeInt} from '@raison/types';
import Currency from '~/shared/legacy_models/Currency/Currency';

class USDCCurrency extends Currency {
    constructor(amount: number | string, decimals_assets?: NonNegativeInt) {
        super(amount, decimals_assets ?? (5 as NonNegativeInt));
        this.transactionsDigits = 6;
    }
}

export default USDCCurrency;
